 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","auth-auth-module":"auth-auth-module","default~app-app-module~basic-forms-basic-forms-module~views-base-base-module":"default~app-app-module~basic-forms-basic-forms-module~views-base-base-module","default~app-app-module~datatable-datatable-module":"default~app-app-module~datatable-datatable-module","default~app-app-module~text-editors-text-editors-module":"default~app-app-module~text-editors-text-editors-module","default~app-app-module~views-notifications-notifications-module":"default~app-app-module~views-notifications-notifications-module","default~app-app-module~toastr-toastr-module":"default~app-app-module~toastr-toastr-module","app-app-module":"app-app-module","views-base-base-module":"views-base-base-module","views-notifications-notifications-module":"views-notifications-notifications-module","default~views-dashboard-dashboard-module~views-theme-theme-module~views-widgets-widgets-module":"default~views-dashboard-dashboard-module~views-theme-theme-module~views-widgets-widgets-module","views-dashboard-dashboard-module":"views-dashboard-dashboard-module","views-widgets-widgets-module":"views-widgets-widgets-module","views-theme-theme-module":"views-theme-theme-module","views-apps-apps-module":"views-apps-apps-module","views-buttons-buttons-module":"views-buttons-buttons-module","views-chartjs-chartjs-module":"views-chartjs-chartjs-module","views-editors-editors-module":"views-editors-editors-module","views-forms-forms-module":"views-forms-forms-module","views-google-maps-google-maps-module":"views-google-maps-google-maps-module","views-icons-icons-module":"views-icons-icons-module","views-plugins-plugins-module":"views-plugins-plugins-module","views-tables-tables-module":"views-tables-tables-module","brand-brand-module":"brand-brand-module","agency-agency-module":"agency-agency-module","bank-bank-module":"bank-bank-module","currency-currency-module":"currency-currency-module","customer-customer-module":"customer-customer-module","security-security-module":"security-security-module","setting-setting-module":"setting-setting-module","default~availability-account-availability-account-module~checkout-checkout-module~invoice-detail-rep~afa42f73":"default~availability-account-availability-account-module~checkout-checkout-module~invoice-detail-rep~afa42f73","availability-account-availability-account-module":"availability-account-availability-account-module","checkout-checkout-module":"checkout-checkout-module","transaction-transaction-module":"transaction-transaction-module","default~department-department-module~invoice-advance-invoice-advance-module~product-product-module":"default~department-department-module~invoice-advance-invoice-advance-module~product-product-module","department-department-module":"department-department-module","product-product-module":"product-product-module","default~invoice-advance-invoice-advance-module~receipt-receipt-advance-receipt-advance-module":"default~invoice-advance-invoice-advance-module~receipt-receipt-advance-receipt-advance-module","default~invoice-invoice-module~receipt-receipt-module":"default~invoice-invoice-module~receipt-receipt-module","invoice-invoice-module":"invoice-invoice-module","document-document-module":"document-document-module","spent-spent-module":"spent-spent-module","tag-tag-module":"tag-tag-module","toastr-toastr-module":"toastr-toastr-module","email-email-module":"email-email-module","invoicing-invoice-module":"invoicing-invoice-module","loading-buttons-loading-buttons-module":"loading-buttons-loading-buttons-module","code-editors-code-editors-module":"code-editors-code-editors-module","text-editors-text-editors-module":"text-editors-text-editors-module","advanced-forms-advanced-forms-module":"advanced-forms-advanced-forms-module","basic-forms-basic-forms-module":"basic-forms-basic-forms-module","validation-forms-validation-forms-module":"validation-forms-validation-forms-module","calendar-calendar-module":"calendar-calendar-module","draggable-cards-draggable-cards-module":"draggable-cards-draggable-cards-module","spinners-spinners-module":"spinners-spinners-module","datatable-datatable-module":"datatable-datatable-module","availability-account-action-availability-account-action-module":"availability-account-action-availability-account-action-module","availability-account-user-availability-account-user-module":"availability-account-user-availability-account-user-module","availability-account-report-availability-account-report-module":"availability-account-report-availability-account-report-module","service-service-module":"service-service-module","product-provider-product-provider-module":"product-provider-product-provider-module","product-transaction-product-transaction-module":"product-transaction-product-transaction-module","default~product-box-product-box-module~product-delivery-product-delivery-module~product-provider-del~7c0268c9":"default~product-box-product-box-module~product-delivery-product-delivery-module~product-provider-del~7c0268c9","product-box-product-box-module":"product-box-product-box-module","product-delivery-product-delivery-module":"product-delivery-product-delivery-module","product-category-product-category-module":"product-category-product-category-module","product-command-product-command-module":"product-command-product-command-module","product-image-product-image-module":"product-image-product-image-module","product-proposition-product-proposition-module":"product-proposition-product-proposition-module","product-type-product-type-module":"product-type-product-type-module","product-unit-product-unit-module":"product-unit-product-unit-module","invoice-product-refund-invoice-product-refund-module":"invoice-product-refund-invoice-product-refund-module","invoice-advance-invoice-advance-module":"invoice-advance-invoice-advance-module","invoice-detail-invoice-detail-module":"invoice-detail-invoice-detail-module","document-type-document-type-module":"document-type-document-type-module","spent-category-spent-category-module":"spent-category-spent-category-module","tag-category-tag-category-module":"tag-category-tag-category-module","availability-account-transaction-availability-account-transaction-module":"availability-account-transaction-availability-account-transaction-module","cash-in-cash-in-module":"cash-in-cash-in-module","cash-out-cash-out-module":"cash-out-cash-out-module","product-provider-payment-slice-product-provider-payment-slice-module":"product-provider-payment-slice-product-provider-payment-slice-module","product-provider-delivery-product-provider-delivery-module":"product-provider-delivery-product-provider-delivery-module","product-provider-command-product-provider-command-module":"product-provider-command-product-provider-command-module","general-box-general-box-module":"general-box-general-box-module","product-delivery-category-product-delivery-category-module":"product-delivery-category-product-delivery-category-module","product-proposition-product-product-proposition-product-module":"product-proposition-product-product-proposition-product-module","invoice-detail-report-invoice-detail-report-module":"invoice-detail-report-invoice-detail-report-module","product-provider-payment-slice-file-product-provider-payment-slice-file-module":"product-provider-payment-slice-file-product-provider-payment-slice-file-module","product-provider-delivery-category-product-provider-delivery-category-module":"product-provider-delivery-category-product-provider-delivery-category-module","general-box-supply-general-box-supply-module":"general-box-supply-general-box-supply-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
